import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  TextField, Typography, Alert,
} from '@mui/material';

export default function RestoreConfirmDialog({ open, backup, onConfirm, onCancel }) {
  const [typed, setTyped] = useState('');

  useEffect(() => { if (!open) setTyped(''); }, [open]);

  if (!backup) return null;
  const match = typed === backup.domain_name;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>This will overwrite the live site</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Restore <strong>{backup.domain_name}</strong> to the backup from{' '}
          <strong>{backup.started_at}</strong>.
        </Alert>
        <Typography variant="body2" paragraph>
          Current site files and database will be replaced.
          A safety backup will be taken automatically before the restore begins.
        </Typography>
        <Typography variant="body2" paragraph>
          To confirm, type the full domain name below:
        </Typography>
        <TextField
          fullWidth
          autoFocus
          size="small"
          label="Type the domain to confirm"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color="error" variant="contained" disabled={!match} onClick={() => onConfirm(backup)}>
          Restore — this is destructive
        </Button>
      </DialogActions>
    </Dialog>
  );
}
